'use client';

import cn from 'classnames';

import { Link } from '@/components/Link';
import { Wrapper } from '@/components/Wrapper';

import s from './About.module.scss';

interface AboutProps {
  content: {
    title: string;
    desc: string;
  };
  links?: { id: string; title: string; link: string }[];
}

const About = ({ links, content }: AboutProps) => {
  return (
    <section className={cn(s.root)}>
      <Wrapper>
        <h2 className={s.title}>{content.title}</h2>
        <div dangerouslySetInnerHTML={{ __html: content.desc }} />

        {links && (
          <div className={s.linksWrapper}>
            {links.map(({ id, title, link }, index) => {
              return (
                <Link
                  key={index}
                  className={cn(s.link, 'link')}
                  href={link}
                  prefetch={false}
                  analyticsOptions={{
                    action: link,
                    clickZone: 'body',
                    clickElement: 'textclick',
                    clickContent: title,
                    uniqueId: id,
                    transitionType: 'inside-link',
                    clickZoneCategory: 'site-body',
                    transitionTypeMetrics: 'internal',
                    transitionUrl: `/career/${link}`,
                  }}
                >
                  {title}
                </Link>
              );
            })}
          </div>
        )}
      </Wrapper>
    </section>
  );
};

export { About };
